import gql from 'graphql-tag';

import client from '../graphqlAPI';

// Creates a program (input.parent = 0) or an episode. `input` is the whole RadioShowInput.
const POST_ADD_RADIO_SHOW = gql`
  mutation postAddRadioShow($input: RadioShowInput!) {
    postAddRadioShow(input: $input) {
      isAuth
      ok
      errors { field message }
      show {
        _id
        id
        parent
        parentSlug
        parentTitle { es ca en pt }
        slug
        title { es ca en pt }
        subtitle { es ca en pt }
        text { es ca en pt }
        status
        highlight
        channel
        image
        imageSquare
        mp3
        fileSize
        mixcloud
        youtube
        spotify
        isPlaylist
        duration
        lang
        appleCategory
        appleSubcategory
        tagIds
        categoryIds
        firstAirDate
        airings { id date channel }
        createdAt
        updatedAt
      }
    }
  }
`;

const postAddRadioShow = async ({ input }) => {
  try {
    const result = await client
      .mutate({
        mutation: POST_ADD_RADIO_SHOW,
        variables: { input },
        fetchPolicy: 'no-cache',
      })
      .then(queryResult => queryResult)
      .catch((queryError) => {
        console.log('\x1b[31m%s\x1b[0m', `${new Date().toLocaleTimeString()} ~ Client: Apollo Client Query Error: ${queryError}`);
        return null;
      });

    const {
      data: { postAddRadioShow: postAddRadioShowData },
    } = result;

    if (postAddRadioShowData) {
      return postAddRadioShowData;
    }
    console.log('\x1b[31m%s\x1b[0m', `${new Date().toLocaleTimeString()} ~ Client: GraphQL Query Error: postAddRadioShow = null`);
    return null;
  } catch (error) {
    console.log('\x1b[31m%s\x1b[0m', `${new Date().toLocaleTimeString()} ~ Client: postAddRadioShow Error: ${error}`);
    return null;
  }
};

export default postAddRadioShow;
